export const AdCreatedIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M2 5.625H12C12.7594 5.625 13.375 6.24061 13.375 7V17C13.375 17.7594 12.7594 18.375 12 18.375H2C1.24061 18.375 0.625 17.7594 0.625 17V7C0.625 6.24061 1.24061 5.625 2 5.625Z"
            stroke="#4DD15E"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M3.5 10.5H5.5V12.5M5.5 12.5V14.5H3.5L2.5 13.5L3.5 12.5H5.5Z" stroke="#4DD15E" strokeLinecap="round" />
        <path
            d="M10.5 8.5V10.5M10.5 10.5V14.5H8.5L7.5 13.75V11.5L8.5 10.5H10.5Z"
            stroke="#4DD15E"
            strokeLinecap="round"
        />
        <path d="M15.5 5.5L21.5 5.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M18.5 2.5L18.5 8.5" stroke="#4DD15E" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
)

export default AdCreatedIcon
